import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify';
import { getUserDetailReport, exportUserDetailsReportCSV } from '../../../axios/Report/ReportUrlApi';
import { useAuth } from '../../../context/AuthContext'
import { ReportPageHeader } from './ReportSharedComponents';

const UserDetailsReport = (props) => {
    const { onBack, setLoading, handleFilter, dataFilter, page, pageSize, getTabName, resetTableData, profile, isAdmin, totalPages } = props;
    const { t, i18n } = useTranslation()
    const currentLang = i18n.language;
    const { dateTimeFormat } = useAuth();

    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);

    const initialFormData = {
        sumBy: "1",
        // Báo cáo chi tiết user không lọc theo ngày; dùng hôm qua cho dialog cập nhật
        startDate: yesterday,
        endDate: yesterday,
        showTime: "h-m-s",
        groupByDevices: false,
        showEvents: false,
        showEventsRadio: "first-and-last"
    }

    const [formData, setFormData] = useState(initialFormData)

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    }

    const handleCheckedChange = (e) => {
        const { name, checked } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: checked,
        }));
    };


    const bodyRequest = {
        // "reportCycleTypeId": formData?.sumBy ? Number(formData.sumBy) : 1,
        // "fromDate": formData.startDate?.target?.value
        //     ? formatDateTime(formData.startDate.target.value)
        //     : formatDateTime(formData.startDate),
        // "toDate": formData.endDate?.target?.value
        //     ? formatDateTime(formData.endDate.target.value)
        //     : formatDateTime(formData.endDate),
        "userId": isAdmin ? (dataFilter?.userName ? dataFilter.userName : null) : profile.userId,
        "userTypeId": null,
        // "shiftId": dataFilter?.shift ? dataFilter.shift : 0,
        "groupId": dataFilter?.userGroup ? dataFilter.userGroup : null,
        "pageNo": page + 1,
        "recordPerPage": pageSize,
        "showTime": formData.showTime,
        "lang": currentLang,
        "timeZone": Intl.DateTimeFormat().resolvedOptions().timeZone,
        "formatDate": dateTimeFormat
    }

    // const bodyRequest = {
    //     "userId": 1017,
    //     "userTypeId": 1,
    //     "groupId": null,
    //     "pageNo": 1,
    //     "recordPerPage": 200
    // }


    const fetchData = async () => {
        resetTableData()
        try {
            setLoading(true);
            const response = await getUserDetailReport(bodyRequest);
            if (response.data.message === 'Successful' || response.data.message === 'Thành công') {
                // setUserData(response.data.listEmployeeData);
                handleFilter({
                    ...response.data, pagination: {
                        ...response.data.pagination,
                        currentPage: response.data.pagination.currentPage - 1
                    }
                });
                setLoading(false);
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            setLoading(false);
            if (error.response) {
                if (error.response.status !== 401) {
                    toast.error(t(error?.response.data));
                }
            } else {
                toast.error(t('common.network-timeout'));
            }
            console.error('Error fetching user list:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (dataFilter?.shift || dataFilter?.userName || page || pageSize) {
            fetchData();
        }
    }, [dataFilter.shift, dataFilter.userName, page, pageSize]);
    // const prevShiftRef = useRef();
    //     useEffect(() => {
    //         if (dataFilter?.shift || dataFilter?.userName || page || pageSize) {
    //             if (JSON.stringify(prevShiftRef.current) !== JSON.stringify(dataFilter.shift) || dataFilter?.userName || page || pageSize) {
    //                 prevShiftRef.current = dataFilter.shift;
    //                 fetchData();
    //             }
    //         }
    //     }, [dataFilter.shift, dataFilter.userName,  formData, page, pageSize]);



    useEffect(() => {
        getTabName("UserDetailsReport")
    }, []);

    function getCurrentTimestamp() {
        const now = new Date();
        const yyyy = now.getFullYear();
        const MM = String(now.getMonth() + 1).padStart(2, '0');
        const dd = String(now.getDate()).padStart(2, '0');
        const HH = String(now.getHours()).padStart(2, '0');
        const mm = String(now.getMinutes()).padStart(2, '0');
        const ss = String(now.getSeconds()).padStart(2, '0');

        return `${yyyy}${MM}${dd}${HH}${mm}${ss}`;
    }

    const exportCSV = async () => {
        const payload = {
            ...bodyRequest,
            pageNo: totalPages
        };
        try {
            setLoading(true);
            const response = await exportUserDetailsReportCSV(payload);

            if (response) {
                const blob = new Blob([response.data], { type: 'application/octet-stream' });
                const url = window.URL.createObjectURL(blob);

                const a = document.createElement('a');
                a.href = url;
                // a.download = 'user-details-report.csv';
                // a.download = "UserDetailsReport_" + getCurrentTimestamp() + ".xlsx";
                const filename = `${t("export.UserDetailsReport")}_${getCurrentTimestamp()}.xlsx`;

                a.download = filename;
                document.body.appendChild(a);
                a.click();
                a.remove();
            }
        } catch (error) {
            setLoading(false);
            if (error.response) {
                if (error.response.status !== 401) {
                    toast.error(t(error?.response.data));
                }
            } else {
                toast.error(t('common.network-timeout'));
            }
            console.error('Error fetching user list:', error);
        } finally {
            setLoading(false);
        }
    };


    return (
        <div className='total-work-hours-report'>
            <ReportPageHeader
                onBack={onBack}
                titleKey="common.user-details-report"
                onExport={exportCSV}
                startDate={formData.startDate}
                endDate={formData.endDate}
                onUpdateSuccess={fetchData}
            />
        </div>
    )
}

export default UserDetailsReport